import styled from '@emotion/styled';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

export type TooltipDivProps = {
  position?: string,
  top?: number,
  left?: number,
  color?: string,
  borderColor?: string,
  width?: string,
  height?: string,
};

const ToolTipDiv = styled.div<TooltipDivProps>`
position: ${({ position }) => position};
top: ${({ top }) => top ?? 0}px;
left: ${({ left }) => left ?? 0}px;
display: flex;
width: ${({ width }) => width || '220px'};
height: ${({ height }) => height || '54px'};
flex-direction: column;
align-items: center;
justify-content: center;
background-color: ${({ color }) => color || colors.black};
border-radius: 6px;

::after { 
  position: absolute; 
  top: 100%;
  border-top: 10px solid ${({ borderColor }) => borderColor || colors.black}; 
  border-right: 5px solid transparent; 
  border-left: 5px solid transparent;
  margin: 0 auto;
  content: "";
}
@media (max-width: ${breakpointSmall}) {
  width: auto;
  height: auto;
  padding: 10px 15px;
}
`;

export default ToolTipDiv;
